import { Translation } from '@ps/web-shared-components';
import { isPast } from 'date-fns';
import fromUnixTime from 'date-fns/fromUnixTime';
import intervalToDuration from 'date-fns/intervalToDuration';
import React from 'react';

import { TXTWCL_N0_D, TXTWCL_N0_H_N1_M, TXTWCL_N0_M } from './formatExpiresTime.messages.json';

const formatExpiresTime = (expiresTime: number) => {
  const unixToExpiresDate = new Date(fromUnixTime(expiresTime));

  if (isPast(unixToExpiresDate)) return null;

  const { days, hours, minutes } = intervalToDuration({
    start: new Date(),
    end: unixToExpiresDate
  });

  if (days && days > 0) {
    return <Translation {...TXTWCL_N0_D} values={{ day: days }} />;
  }

  if (hours && hours > 0) {
    return <Translation {...TXTWCL_N0_H_N1_M} values={{ time: hours, 1: minutes }} />;
  }

  return <Translation {...TXTWCL_N0_M} values={{ minutes }} />;
};

export default formatExpiresTime;
